"use strict";
/**
 * The applications module provides access to the applications data from the EVA back-end
 * @preferred
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_1 = require("./base");
var settings_1 = require("../settings");
var service_1 = require("../service");
var xhr_1 = require("../xhr");
/**
 * Provides access to a babylon binary blobs in EVA
 */
var Blob = /** @class */ (function (_super) {
    __extends(Blob, _super);
    function Blob() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Convenience method to build a blob image URL
     * @param  {string} guid        The blob guid
     * @param  {number} width       The output image width
     * @param  {number} height      The output image height
     * @param  {string} type        The image type (ie. png, jpg, etc)
     *
     * @return {string}             An image URL
     */
    Blob.getImageUrl = function (guid, width, height, format) {
        if (width === void 0) { width = 100; }
        if (height === void 0) { height = 100; }
        if (format === void 0) { format = "png"; }
        return settings_1.SettingsManager.getEndPointURL() + ("/image/" + Math.round(width) + "/" + Math.round(height) + "/" + guid + "." + format);
    };
    /**
     * Sets the category to retrieve the blob info for
     * @param  {string} category    The blob category
     * @return {void}               This method doesn't return anything
     */
    Blob.prototype.setCategory = function (category) {
        this.category = category;
    };
    /**
     * Sets the original name to retrieve the blob info for
     * @param  {string} original name    The blob original name
     * @return {void}               This method doesn't return anything
     */
    Blob.prototype.setOriginalName = function (originalName) {
        this.originalName = originalName;
    };
    Blob.prototype.fetch = function () {
        // Build the request data
        //
        var requestData = {
            Guid: this.getId(),
            Category: this.category,
            OriginalName: this.originalName
        };
        if (this.getId() === undefined) {
            return Promise.reject({
                status: 404,
                response: "Not found"
            });
        }
        else {
            return _super.prototype.fetch.call(this, "GetBlobInfo", requestData, "/api/v1/blob/" + this.getId() + "/info", xhr_1.EXMLHttpRequestMethod.GET);
        }
    };
    /**
     * Sets the current item details using the fetched service response.
     * Extending classes should override this method to pull the details from response
     * @param  {RES} response The response from the service call
     * @return {T}            The item details
     */
    Blob.prototype.setData = function (response) {
        // The default response is usually EVA.Core.GetResponse
        // An extending class will know exactly what is returned and where
        // the data for <T> can be found
        //
        return this.data = response;
    };
    Blob.prototype.create = function (newBlobInfo) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            // Create the service instance
            //
            var service = new service_1.EVAService("StoreBlob", "/api/v1/blob", xhr_1.EXMLHttpRequestMethod.POST);
            // Perform the call and capture the resulting promise
            //
            service.call(newBlobInfo)
                .then(function (createResult) {
                // Collect the ID from the response
                //
                _this.id = createResult.response.Guid;
                // Return the fetch of the newly created blob
                //
                _this.fetch().then(resolve).catch(reject);
            })
                .catch(reject);
        });
    };
    Blob.prototype.createEmpty = function (newBlobInfo) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            // Create the service instance
            //
            var service = new service_1.EVAService("CreateBlob", "/api/v1/blob/empty", xhr_1.EXMLHttpRequestMethod.POST);
            // Perform the call and capture the resulting promise
            //
            service.call(newBlobInfo)
                .then(function (createResult) {
                // Collect the ID from the response
                //
                _this.id = createResult.response.Guid;
                // Resolve with the upload URL
                //
                resolve(createResult.response.Url);
            })
                .catch(reject);
        });
    };
    Blob.prototype.createEmptyBlob = function (newBlobInfo) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            // Create the service instance
            //
            var service = new service_1.EVAService("CreateBlob", "/api/v1/blob/empty", xhr_1.EXMLHttpRequestMethod.POST);
            // Perform the call and capture the resulting promise
            //
            service.call(newBlobInfo)
                .then(function (createResult) {
                // Collect the ID from the response
                //
                _this.id = createResult.response.Guid;
                // Resolve with the upload URL
                //
                resolve(createResult.response);
            })
                .catch(reject);
        });
    };
    Blob.prototype.getUploadUrl = function (guid) {
        return settings_1.SettingsManager.getEndPointURL() + ("/blob/" + guid);
    };
    Blob.prototype.process = function (imageDataBase64, type) {
        // Create the service instance
        //
        var service = new service_1.EVAService("ProcessDocument", "/api/v1/blob/process", xhr_1.EXMLHttpRequestMethod.POST);
        // Build the request data
        // The base class will add things like SessionID so keep typescript
        // happy we're using an 'any' type object here
        //
        var requestData = {
            Data: imageDataBase64,
            Type: type
        };
        // Perform the call and capture the resulting promise
        //
        return service.call(requestData);
    };
    Blob.prototype.destroy = function () {
        // Create the service instance
        //
        var service = new service_1.EVAService("DeleteBlob", "/api/v1/blob/" + this.getId(), xhr_1.EXMLHttpRequestMethod.DELETE);
        // Build the request data
        // The base class will add things like SessionID so keep typescript
        // happy we're using an 'any' type object here
        //
        var requestData = {};
        // Perform the call and capture the resulting promise
        //
        return service.call(requestData);
    };
    return Blob;
}(base_1.FetchableItem));
exports.Blob = Blob;
